
import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Crown, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const PremiumFeatureTeaser: React.FC = () => {
  return (
    <Card className="bg-gradient-to-r from-purple-50 to-blue-50 dark:from-purple-900/20 dark:to-blue-900/20 border-purple-200 dark:border-purple-800">
      <CardContent className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center gap-2">
            <Crown className="h-5 w-5 text-purple-600" />
            <Badge variant="secondary" className="bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-100">
              Premium
            </Badge>
          </div>
          <Sparkles className="h-4 w-4 text-purple-500" />
        </div>
        
        <h3 className="text-xl font-semibold mb-2">
          Unlock Premium Features
        </h3>
        
        <p className="text-muted-foreground mb-4">
          Get unlimited prompt copies, AI chat messages, and Product Copilot credits to supercharge your productivity.
        </p>
        
        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Starting at <span className="font-semibold text-foreground">$10/month</span>
          </div>
          
          <Button asChild size="sm" className="group">
            <Link to="/pricing">
              Upgrade Now
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PremiumFeatureTeaser;
